export default __webpack_public_path__ + "static/media/identity.8bfad2d6.svg";